import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';
import "flatpickr/dist/themes/airbnb.css";

import { Armenian } from "../other/flatpickr/hy"
import { Russian } from "flatpickr/dist/l10n/ru.js"

const Wrapper = require('./Wrapper');
const { getLanguage } = require('../../entryPoints/layout/js/multilanguage');
const confirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate');

class DatepickerWrapper extends Wrapper {
    constructor(inputId) {
        super();

        this.element = document.getElementById(inputId);

        let config = {
            enableTime: true,
            dateFormat: "d.m.Y H:i",
            time_24hr: true,
            disableMobile: "true",
            plugins: [new confirmDatePlugin({})]
        };

        let lang = getLanguage();

        if(lang === 'am') config['locale'] = Armenian;
        if(lang === 'ru') config['locale'] = Russian;

        this.datetime = flatpickr("#" + inputId, config);

        this.model = {
            value: 0
        };

        this.required = true;

        this.initEvents();
    }

    isValid() {
        return !this.required || Boolean(this.model.value);
    }

    validate() {
        if(this.isValid()) {
            this.element.classList.remove('invalid');
        } else {
            this.element.classList.add('invalid');
            if(this.element.scrollIntoView) this.element.scrollIntoView();
        }
    }

    set minDate(value) {
        this.datetime.config.minDate = value;
    }

    set maxDate(value) {
        this.datetime.config.maxDate = value;
    }

    updateUI() {
        if(this.model.value == 0)
        {
            this.element.value = '';
        } else
        {
            this.datetime.setDate(this.model.value);
        }
        this.autoValidation = true;
    }

    initEvents() {
        $(this.element).on('change', () => {
            this.updateModel({
                value: Number(this.datetime.latestSelectedDateObj) || 0
            });

            if(this.model.value === 0) {
                window.$(this.clearBtn).hide();
            } else {
                window.$(this.clearBtn).show();
            }
        });

        // clear buttond
        this.clearBtn = document.createElement('i');
        window.$(this.clearBtn).attr('class', 'fa fa-close button-clear');
        window.$(this.clearBtn).attr('title', 'Մաքրել');
        window.$(this.clearBtn).hide();
        this.element.parentElement.appendChild(this.clearBtn);

        this.clearBtn.addEventListener('click', () => {
            this.datetime.clear();
            window.$(this.clearBtn).hide();
        })
    }
}

module.exports = DatepickerWrapper;